module.exports = __webpack_public_path__ + "01_medium_gray.c8211cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_medium_gray.png
// module id = wNVQ
// module chunks = 0